// Manual da Recepção dentro do app DNA (pedido do dono, 14/10/2026: "subir o
// manual de recepcionistas para TODAS as recepcionistas no aplicativo do DNA").
// Regras PURAS (sem React, sem window), testadas em tests/manual-recepcao-app.test.mjs:
//   · quem abre: Recepcionista e Gerente (pelo menu) e o master (pela URL; ele
//     segue com a aba Reuniões). Os outros cargos não ganham nada.
//   · onde a leitura parou: o slide atual fica salvo no aparelho ("N/TOTAL") e
//     a próxima abertura retoma dali (no último slide, recomeça do 1).
//   · mensagens do deck (iframe) para a página: só { fkDeck: 'voltar' | 'slide' | 'pronto' }.
export const MANUAL_RECEPCAO_ROTA = '/gestao/manual-recepcao';
export const CARGOS_MANUAL_RECEPCAO = new Set(['Recepcionista', 'Gerente']);
export const MANUAL_RECEPCAO_CHAVE = 'fk_manual_recepcao_slide';

const MAX_SLIDES = 999;
const inteiroPositivo = (v) => {
  const s = typeof v === 'number' ? String(v) : typeof v === 'string' ? v.trim() : '';
  if (!/^\d{1,3}$/.test(s)) return null;
  const n = Number(s);
  return n >= 1 && n <= MAX_SLIDES ? n : null;
};

export function podeManualRecepcao({ cargo, isMaster } = {}) {
  return !!isMaster || CARGOS_MANUAL_RECEPCAO.has(cargo);
}

// Slide salvo → slide inicial (1-based). Aceita "12" (total = o padrão) ou
// "12/64" (o total do deck quando foi salvo). Válido (1..total-1) retoma;
// vazio, lixo, fora da faixa ou o ÚLTIMO slide (leitura terminada) → 1.
export function slideInicial(salvo, total = 64) {
  let txt = salvo;
  let tot = inteiroPositivo(total) || 64;
  if (typeof salvo === 'string' && salvo.includes('/')) {
    const [a, b, ...resto] = salvo.split('/');
    if (resto.length) return 1;
    const t = inteiroPositivo(b);
    if (!t) return 1;
    txt = a;
    tot = t;
  }
  const n = inteiroPositivo(txt);
  return n && n < tot ? n : 1;
}

// O que guardar no aparelho para o slide n de total ("12/64").
export function valorSalvo(n, total) {
  return `${n}/${total}`;
}

// Mensagem do deck → ação da página:
//   { fkDeck: 'voltar' }                         → { tipo: 'voltar' }
//   { fkDeck: 'slide' | 'pronto', n, total, … }  → { tipo: 'salvar', n, total }
//   qualquer outra coisa (lixo, n fora da faixa, sem fkDeck) → null
export function acaoDaMensagem(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
  const tipo = data.fkDeck;
  if (tipo === 'voltar') return { tipo: 'voltar' };
  if (tipo !== 'slide' && tipo !== 'pronto') return null;
  if (!Number.isInteger(data.n) || !Number.isInteger(data.total)) return null;
  const { n, total } = data;
  if (total < 1 || total > MAX_SLIDES || n < 1 || n > total) return null;
  return { tipo: 'salvar', n, total };
}
